var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"radio-box"},_vm._l((_vm.getTotalRadio),function(radio){return _c('input',{key:radio.id,staticClass:"radio",attrs:{"type":"radio","name":"part"},on:{"click":function($event){return _vm.changeSection(radio)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }